module.exports = __webpack_public_path__ + "img/MapPicsTundra.741d6aa7.webp";